import { render, staticRenderFns } from "./ChatButton.vue?vue&type=template&id=537f527f&scoped=true&"
import script from "./ChatButton.vue?vue&type=script&lang=js&"
export * from "./ChatButton.vue?vue&type=script&lang=js&"
import style0 from "./ChatButton.vue?vue&type=style&index=0&id=537f527f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537f527f",
  null
  
)

export default component.exports